import { render, staticRenderFns } from "./appltInfo.vue?vue&type=template&id=10ce5f80&scoped=true"
import script from "./appltInfo.vue?vue&type=script&lang=js"
export * from "./appltInfo.vue?vue&type=script&lang=js"
import style0 from "./appltInfo.vue?vue&type=style&index=0&id=10ce5f80&prod&lang=less&scoped=true"
import style1 from "./appltInfo.vue?vue&type=style&index=1&id=10ce5f80&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce5f80",
  null
  
)

export default component.exports